import { apiRoutes } from '@/config/api-routes'
import { ibgeApi } from '@/lib/axios'

export interface State {
  name: string
  uf: string
}

export interface City {
  name: string
}

export async function getStates(): Promise<State[]> {
  const response = await ibgeApi.get(apiRoutes.getStates)
  const states = response.data.map((state: any) => ({
    name: state.nome,
    uf: state.sigla,
  }))
  return states
}

export async function getCities(uf: string): Promise<City[]> {
  const response = await ibgeApi.get(apiRoutes.getCities(uf))
  const cities = response.data.map((city: any) => ({
    name: city.nome,
  }))
  return cities
}
